import React, { useState } from 'react'
import { MdDeleteForever } from "react-icons/md";

const LaneHeader = ({
  updateTitle, canAddLanes, onDelete, onDoubleClick, editLaneTitle, label, title, titleStyle, labelStyle, t, laneDraggable, desc
}: any) => {
  const [_title, setTitle] = useState(title)
  const [_desc, setDesc] = useState(desc)

  return (
    <header onDoubleClick={onDoubleClick}>
      <div style={{...titleStyle, cursor: laneDraggable ? 'grab' : 'auto'}}>
        <div className='flex'>
          {
            editLaneTitle 
            ? <input 
              type="text"
              name="title"
              className="
                w-full
                block
                border-none
                bg-transparent
                text-gray-600
                font-bold
                placeholder:italic
                focus:border-none focus:ring focus:ring-transparent
                "
              placeholder="Nom de la séquence"
              value={_title}
              onBlur={updateTitle.bind(this, _title, 'title')}
              onChange={(e) => setTitle(e.target.value)}
            />
            : <span>{title}</span>
          }
          <div className='flex justify-center items-center'>
            {label && (
              <span style={labelStyle} className='text-gray-600 font-bold text-xs'>{label}</span>
            )}
            {canAddLanes && <MdDeleteForever className='ml-2 text-red-500' onClick={onDelete}/>}
          </div>
        </div>
        { editLaneTitle
          ?
            <textarea rows={3} name="desc" style={{ resize: 'none'}} className="
              placeholder:italic
              w-full
              block
              border-none
              bg-transparent
              text-gray-600
              text-xs
              italic
              focus:border-none focus:ring focus:ring-transparent
            " placeholder="Objectif de la séquence" value={_desc} onBlur={updateTitle.bind(this, _desc, 'desc')} onChange={(e) => setDesc(e.target.value)} />
          : <p>
            {desc}
          </p>
        }
      </div>
    </header>
  )
}

export default LaneHeader; 